import { IValidationRule } from "@/types"

const labelCategoryValidationRules: { [s: string]: IValidationRule } = {
    labelCategoryName: {
        required: true,
    },
}

export default labelCategoryValidationRules
